import { MonocleFor } from '@morphic-ts/adt/es6/monocle';
import { interpretable } from './programs-infer';
import { assignCallable, assignFunction, inhabitTypes, wrapFun } from './utils';
const inhabitInterpreterAndAlbegra = (t) => t;
function interpreteWithProgram(program, programInterpreter) {
    return inhabitInterpreterAndAlbegra(inhabitTypes(assignFunction(wrapFun(program), programInterpreter(program)))); // FIXME: resolve any
}
/**
 *  @since 0.0.1
 */
export function materialize(program, programInterpreter) {
    const morph = interpreteWithProgram(program, programInterpreter);
    return assignCallable(morph, Object.assign(Object.assign({}, MonocleFor()), { derive: interpretable(morph) }));
}
